<template>
    <div>

        <h1 class="fd-news-title">{{ data.bt }}</h1>
        <div class="fd-news-message">
            <p>发布时间：{{ dateFormat(data.fbsj, 'yyyy-MM-dd') }}</p>
            <p>发布法院：{{ data.fbdwTranslateText }}</p>
            <div class="fd-detail-cz">
                <div class="fd-font-cz">字号：
                    <span class="fd-large" @click="addFontSize"></span>
                    <span class="fd-narrow" @click="narFontSize"></span>
                </div>
                <div class="fd-print" @click="printPage">打印本页</div>
            </div>
        </div>
        <div :style="{'font-size':`${fontSize}px`,'color': 'black' }" v-html="data.zw" class="fd-detail-con"></div>
        <div v-if="xgfj.length">
            <div class="fd-xgfj-title">相关附件</div>
            <div class="fd-xgfj-list"
                 v-for="(item, index) in xgfj"
                 :key="`xgfj${index}`"
                 @click="downloadFiles(item.url,item.name)"
                 v-text="item.name"></div>
        </div>
    </div>

</template>

<script>
export default {
    name: 'index',
    data() {
        return {
            navList: [],
            fbsj: '',
            xgfj:[],
            uploadParams: {
                businessId: '',
                type: 24
            },
            fbdw: '',
            data:{
                fbdw: '',
                fbsj: '',
            },
            fontSize:18,

        };
    },
    created() {
      //  this.fbdw = this.$route.query.fbdw;
      //  this.fbsj = this.$route.query.fbsj;
        this.getData();
        this.initFiles();

    },
    methods:{
        getData() {
            const _url = window.fdConfig.url.zt.xqhssp.replace('{id}', this.$route.query.id);
            console.log(666);
            window.fdGlobal.ajax({
                methods: window.fdConfig.methodGet,
                url:_url
              //  url: window.fdConfig.url.zt.ztwz.replace('{id}', this.data.bh)
            }).then((res) => {
                this.data = res.data;
                console.log(res.data);
                this.data.zhxgsj = this.data.zhxgsj.slice(0, 10);
                this.data.zw = this.data.zw.replace(/font-size/g, '');
                this.data.zw = this.data.zw.replace(/line-height/g, '');
                this.data.fbsj= res.data.fbsj;
                this.data.fbdw= res.data.fbdw;
            });
        },
        addFontSize() {
            this.fontSize += 2;
        },
        narFontSize() {
            if (this.fontSize > 10) {
                this.fontSize -= 2;
            }
        },
        // 打印页面
        printPage() {
            // 调用打印功能
            window.print();
        },
        initFiles() {
            console.log(111);
            this.uploadParams.businessId = this.$route.query.id;
            const url = window.fdConfig.url.common.getFile;
            window.fdGlobal.ajax({
                url: url,
                methods: window.fdConfig.methodGet,

                params: this.uploadParams
            }).then((res) => {
                if (res.data.length) {
                    res.data.forEach(e => {
                        const zc = {
                            name: e.wjmc,
                            url: e.bh
                        };
                        this.xgfj.push(zc);
                    });
                }
            });
        },
        downloadFiles(bh, name) {
            window.fdGlobal.ajax({
                method: window.fdConfig.methodGet,
                url: window.fdConfig.url.common.downloadFile.replace('{id}', bh),

                contentType: 'application/json;charset=utf-8',
                responseType: 'blob'
            }).then((res) => {
                const binaryData = [];
                const template = res.data;
                binaryData.push(template);
                const blob = new Blob(binaryData);
                // 非IE下载
                if ('download' in document.createElement('a')) {
                    const elink = document.createElement('a');
                    elink.download = name;
                    elink.style.display = 'none';
                    elink.href = URL.createObjectURL(blob);
                    document.body.appendChild(elink);
                    elink.click();
                    URL.revokeObjectURL(elink.href);
                    // 释放URL 对象
                    document.body.removeChild(elink);
                } else {
                    // IE10+下载
                    navigator.msSaveBlob(blob, name);
                }
            });
        }
    }
};
</script>

<style lang="less" scoped>

    .fd-voice-bg {
        margin: 0 auto 44px;
        padding: 55px 0;
        width: 768px;
        height: 512px;
        background-color: #000;

        video {
            width: 100%;
            height: 100%;
        }
    }

    .fd-xgfj-title {
        margin-top: 45px;
        padding-left: 23px;
        color: #000;
        font-size: 16px;
        line-height: 26px;
        letter-spacing: 1px;
        background: url(~@/images/common/icon-file.png) left center no-repeat;
    }

    .fd-xgfj-list {
        margin-top: 8px;
        margin-left: 23px;
        color: #0053b4;
        font-size: 16px;
        line-height: 21px;
        cursor: pointer;
    }

</style>
